<template>
  <div class="bookInfo-container">
    <div class="bookInfo-main">
      <div class="bookInfo-content" v-bar>
        <div>
          <el-card class="bookInfo-card" :body-style="{ padding: '20px' }">
            <div class="itemBook" v-if="isDisabled">
              {{ $t("content.books.createTip") }}
            </div>
            <el-form
              @submit.native.prevent
              :model="form"
              ref="form"
              :rules="rules"
              label-width="80px"
            >
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item
                    :label="$t('content.books.bookName')"
                    prop="name"
                  >
                    <el-input
                      :disabled="isDisabled"
                      v-model="form.name"
                      :placeholder="$t('placeholder.bookName')"
                    ></el-input>
                  </el-form-item>
                  <!-- <el-form-item class="bookInfo-category" :label="$t('content.books.classify')">
                                        <select name="" id="">
                                            <option value="0">{{$t('placeholder.select')}}</option>
                                            <option value="1">{{$t('content.books.publish')}}</option>
                                            <option value="2">{{$t('content.books.boy')}}</option>
                                            <option value="3">{{$t('content.books.girl')}}</option>
                                        </select>
                                    </el-form-item> -->
                  <el-form-item :label="$t('commonMsg.author')" prop="author">
                    <el-input
                      v-model="form.author"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('content.books.price')">
                    <el-input v-model="form.price"></el-input>
                    <p style="fontSize:12px">
                      {{ $t("content.books.priceTip") }}
                    </p>
                  </el-form-item>
                  <el-form-item
                    :label="$t('content.books.uploadFile')"
                    prop="size"
                    v-if="!$route.query.bookId"
                  >
                    <el-upload
                      action=""
                      class="upload-demo"
                      ref="upload"
                      :on-change="handleChange"
                      :file-list="fileList"
                      :auto-upload="false"
                      :limit="1"
                      :http-request="httpRequest"
                      :on-exceed="handleExceed"
                      :before-remove="beforeRemove"
                    >
                      <el-button slot="trigger" size="small" type="primary">{{
                        $t("content.books.selectFile")
                      }}</el-button>
                      <el-button
                        style="margin-left: 10px;"
                        size="small"
                        type="success"
                        @click="submitUpload"
                        >{{ $t("content.books.uploadServer") }}</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        {{ $t("content.books.uploadTip") }}
                      </div>
                    </el-upload>
                  </el-form-item>
                  <el-form-item :label="$t('content.books.fileSize')">
                    <el-input
                      v-model="form.size"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('content.books.fileFormat')">
                    <el-input
                      v-model="form.format"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('content.books.count')">
                    <el-input
                      v-model="form.word_count"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="ISBN">
                    <el-input
                      v-model="form.isbn"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('content.books.pic')" prop="cover">
                    <el-upload
                      class="avatar-uploader"
                      ref="uploadCover"
                      action="/"
                      :on-change="coverPreview"
                      :auto-upload="false"
                      :show-file-list="false"
                    >
                      <img v-if="form.cover" :src="form.cover" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      <div class="el-upload__tip" slot="tip">
                        {{ $t("content.books.picRemark") }}
                      </div>
                    </el-upload>
                  </el-form-item>
                  <el-form-item :label="$t('content.books.publisher')">
                    <el-input
                      v-model="form.publisher"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('content.books.publish_time')">
                    <el-date-picker
                      v-model="form.publish_time"
                      type="date"
                      :placeholder="$t('placeholder.date')"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('content.books.edition')">
                    <el-input
                      v-model="form.edition"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item :label="$t('content.books.bookDescription')">
                    <el-input
                      type="textarea"
                      v-model="form.info"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('content.books.author')">
                    <el-input
                      type="textarea"
                      v-model="form.authorInfo"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item
                class="bookInfo-putaway"
                :label="$t('content.books.condition')"
                prop="status"
              >
                <el-radio-group v-model="form.status">
                  <el-radio :label="1">{{
                    $t("content.books.putaway")
                  }}</el-radio>
                  <el-radio :label="0">{{
                    $t("content.books.notPutaway")
                  }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </div>
    </div>
    <transition name="fade">
      <addBookList
        key="addBookList"
        :title="$t('content.books.selectClassify')"
        :channles="listData"
        @confirmEvn="confirmEvn"
        v-if="showAddBookList"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { uploadOss } from "@/utils/aliyun";
import addBookList from "@/components/addBookList";

import axios from "axios";
export default {
  computed: {
    ...mapGetters(["showAddBookList", "buckets"]),
    rules() {
      let rules = {
        name: [
          {
            required: true,
            message: this.$t("verify.bookName"),
            trigger: "blur"
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        category: [
          {
            required: true,
            message: this.$t("verify.addClassify"),
            trigger: "blur"
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        author: [
          {
            required: true,
            message: this.$t("verify.authorName"),
            trigger: "blur"
          }
        ],
        price: [
          { required: true, message: this.$t("verify.price"), trigger: "blur" }
        ],
        info: [
          {
            required: true,
            message: this.$t("verify.bookDescription"),
            trigger: "blur"
          }
        ],
        cover: [
          { required: true, message: this.$t("verify.cover"), trigger: "blur" }
        ],
        status: [
          {
            required: true,
            message: this.$t("verify.condition"),
            trigger: "blur"
          }
        ]
      };
      return rules;
    }
  },
  components: {
    addBookList
  },
  data() {
    return {
      listData: [],
      form: {
        name: "", // 书名
        author: "", // 作者
        categoryId: "", // 分类
        authorInfo: "", // 作者简介
        info: "", // 产品简介
        price: 0, // 价格
        size: 0, // 大小
        format: "", //	格式
        word_count: 0, // 字数
        categories: [], // 分类
        isbn: "",
        publisher: "", // 出版社
        publish_time: Date, // 出版时间
        edition: "", // 出版批次
        cover: "", // 封面
        url: "", //上传文件
        status: 1 // 0，未发布，1 已经发布（默认1）
      },
      fileList: [],
      coverFile: null,
      isDisabled: true
    };
  },
  methods: {
    getBookDetails() {
      this.$http.getBookDetails(this.$route.query.bookId).then(res => {
        this.isDisabled = false;
        this.$emit("isLogFn", res.ebook_id);
        this.form = Object.assign(this.form, res);
      });
    },
    submitUpload(file) {
      const uploadBooks = {
        file: this.$refs.upload.uploadFiles[0],
        cateId: this.$route.query.id
      };
      this.$refs.upload.submit();
    },
    httpRequest(params) {
      let param = new FormData();
      param.append("file", params.file);
      param.append("cateId", this.$route.query.id);
      axios
        .post(`/api/1/books/upload`, param, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(res => {
          this.isDisabled = false;
          this.form = res.data[0];
          this.form.status = 1;
          this.$emit("isLogFn", res.data[0].id);
        })
        .catch(err => {});
    },
    handleChange(file, fileList) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "txt";
      const extension2 = testmsg === "apk";
      const extension3 = testmsg === "epub";
      const extension4 = testmsg === "pdf";
      const extension5 = testmsg === "xlsx";
      const extension6 = testmsg === "xls";
      const extension7 = testmsg === "doc";
      const extension8 = testmsg === "docx";
      const extension9 = testmsg === "ppt";
      const extension10 = testmsg === "pptx";
      const isLt2M = file.size / 10240 / 10240 < 10;
      if (
        !extension &&
        !extension2 &&
        !extension3 &&
        !extension3 &&
        !extension4 &&
        !extension5 &&
        !extension6 &&
        !extension7 &&
        !extension8 &&
        !extension9 &&
        !extension10
      ) {
        this.elMsg(this.$t("alertMsg.uploadFormat"), "warning");
        this.fileList = [];
        return;
      }
      if (!isLt2M) {
        this.elMsg(this.$t("alertMsg.uploadSize"), "warning");
        this.fileList = [];
        return;
      }
      return extension || (extension2 && isLt2M);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`${this.$t("alertMsg.removeTip")} ${file.name}？`);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    async addCategory() {
      this.$store.commit("windowHandle", "showAddBookList");
    },
    coverPreview(file) {
      this.coverFile = file;
      let coverUrl = URL.createObjectURL(file.raw);
      this.form.cover = coverUrl;
    },
    confirmEvn(gloup) {
      if (this.form.categories.some(item => item.id === gloup.id)) return;
      this.form.categoryId = gloup.id;
      this.form.categories = [];
      this.form.categories = [...this.form.categories, gloup];
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.coverFile) {
            let { bucket, region } = this.buckets["onyx-avatar"];
            let url = await uploadOss(
              this.coverFile,
              bucket,
              undefined,
              region
            );
            this.form.cover = url;
            // this.form.url = url;
            this.$emit("bookHandle", this.form);
          } else {
            this.$emit("bookHandle", this.form);
          }
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    if (!this.$route.query.bookId) return;
    this.getBookDetails();
  }
};
</script>

<style lang="scss">
.bookInfo-container {
  flex: 1;
  overflow: hidden;
  > .bookInfo-main {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .bookInfo-content {
      overflow: hidden;
      flex: 1;
      .bookInfo-card {
        margin: 20px;
        .itemBook {
          width: 100%;
          padding: 0 0 10px 0;
          text-align: center;
          line-height: 30px;
          font-size: 16px;
          font-weight: 400;
          color: red;
        }
      }
    }
  }
  .bookInfo-putaway {
    > .el-form-item__label {
      line-height: 32px !important;
    }
  }
  .bookInfo-category {
    > .el-form-item__label {
      line-height: 32px !important;
    }
    > .el-form-item__content {
      /*line-height: 32px !important;*/
      select {
        height: 40px;
        width: 130px;
        background-color: #ffffff;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        color: #606266;
        padding: 0 15px;
      }
    }
  }
}
</style>
